import { useQuery, gql } from '@apollo/client';

export const GET_PLATFORM_COMPANY_LOCATIONS = gql`
  query getPlatformCompanyLocations {
    getPlatformCompanyLocations {
      _id
      companyId
      name
      companyNumber
    }
  }
`;

export const useGetPlatformCompanyLocations = () => {
  const { data, loading } = useQuery(GET_PLATFORM_COMPANY_LOCATIONS, {
    fetchPolicy: 'network-only',
  });

  return {
    companyLocations: data?.getPlatformCompanyLocations || [],
    loading,
  };
};
